import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { setAuthorization } from "../helpers/api_helper";
import { useDispatch } from "react-redux";

import { useProfile } from "../Components/Hooks/UserHooks";
import { logoutUser } from "../slices/auth/login/thunk";
import { LoadingFallback } from "../Components/Common/LoadingFallback";

function parseJwt(token) {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    return null;
  }
}

const AuthProtected = (props) => {
  const dispatch = useDispatch();
  const { userProfile, loading, token } = useProfile();

  useEffect(() => {
    if (token) {
      setAuthorization(token);
    }
  }, [token]);

  if (loading) {
    return <LoadingFallback />;
  }

  if (!userProfile || !token) {
    return <Navigate to="/login" />;
  }

  const decodedJwt = parseJwt(token);
  if (decodedJwt && decodedJwt.exp * 1000 < Date.now()) {
    localStorage.clear();
    dispatch(logoutUser());
    return <Navigate to="/login" />;
  }

  return <>{props.children}</>;
};

export { AuthProtected };
